import { Injectable } from '@angular/core';
import { convertionAmount, ConvertionApp, convertionCurrency } from './google-analitycs.config';
declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalitycsService {
  constructor() {}

  trackPage(payload = {}) {
    if (typeof gtag != 'undefined') {
    gtag('event', 'page_view', payload);
    }
  }

  trackConversion(code: string) {
    if (typeof gtag != 'undefined') {
      gtag('event', 'conversion', { send_to: 'AW-11410335507/uxggCNzNovYZEJPO78Aq' });
      gtag('event', ConvertionApp.ACCOUNT_PEN, { 
        value: convertionAmount.ACCOUNTS, 
        currency: convertionCurrency.PEN
      });

    }
  }

  trackConversionUSD() {
    if (typeof gtag != 'undefined') {
      gtag('event', 'conversion', { send_to: 'AW-11410335507/uxggCNzNovYZEJPO78Aq' });
      gtag('event', ConvertionApp.ACCOUNT_USD, { 
        value: convertionAmount.ACCOUNTS, 
        currency: convertionCurrency.USD
      });
    }
  }

  /*
      page_location: window.location.href,
      page_path:  window.location.hash,
      page_title:  document.title,
  */

  trackConversionProgrammatic() {
    if (typeof gtag != 'undefined') {
      gtag('event', 'conversion', {
        allow_custom_scripts: true,
        send_to: 'DC-11324528/invmedia/pe_pi0+standard',
      });
    }
  }

  trackConverstionEnrollment() {
      gtag('event', ConvertionApp.ENROLLEMENT, 
         { 
        }
      );
  }


  trackConversionDPF(gtmConversion: any) {
    if (typeof gtag != 'undefined') {
      gtag('event', 'conversion', { send_to: 'AW-11410335507/uxggCNzNovYZEJPO78Aq' });
      gtag('event', ConvertionApp.DPF, { 
        value: gtmConversion.value, 
        currency: gtmConversion.currency
      });
    }
  }
}
